import { CHANGE_NAV } from './type'

const state={
	navStatus: 0 
};

const getters = {
	getNavStatus(state){
		return state.navStatus;   //获取导航状态
	}
};

const mutations = {
	[CHANGE_NAV](state,sel) {
		state.navStatus = sel     //切换导航
	}
};

export default {
	state,
	mutations,
	getters
}


// WEBPACK FOOTER //
// ./src/store/mutations.js